import { ObjectOps } from '../lift';
/**
 * Returns whether this object contains a specific key.
 */
export function contains(key) {
    return this.value().hasOwnProperty(key);
}
ObjectOps.prototype.contains = contains;
